@defer {
  <ag-grid-angular
    style="width: 100%; height: 100%;"
    [gridOptions]="gridOptions()"
    [columnDefs]="columnDefs()"
    [defaultColDef]="defaultColDef"
    [autoGroupColumnDef]="autoGroupColumnDef()"
    [rowData]="rowData()"
    [loading]="loading()"
    (gridReady)="onGridReady($event)"
    (firstDataRendered)="onFirstDataRendered($event)">
  </ag-grid-angular>
}
